import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";

import { GeneralService } from "src/app/services/general.service";
import { CommunicationService } from "src/app/services/communication.service";

import { timeout } from "rxjs/operators";
import { MockStoreService } from "src/app/services/mock-store.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  constructor(
    private fb: FormBuilder,
    private commservice: CommunicationService,
    private generalservice: GeneralService,
    private router: Router,
    private mockstore: MockStoreService
  ) {}

  ngOnInit() {
    this.loginForm = this.fb.group({
      emailOrPassword: ["", Validators.required],
      password: ["", Validators.required]
    });
  }

  submitForm(form: FormGroup) {
    if (!window.navigator.onLine) {
      this.generalservice.warningNotification(
        "You do not have an active internet connection!"
      );
      return;
    }
    const { emailOrPassword } = form.value;
    let formToSubmit = this.checkIfUserEnteredAnEmailOrPassword(
      emailOrPassword
    );
    formToSubmit = { ...formToSubmit, password: form.value.password };
    const loginBtn = document.getElementById("loginBtn") as HTMLButtonElement;
    loginBtn.innerHTML = this.mockstore.spinner;
    loginBtn.disabled = true;
    this.commservice
      .sendLoginDetailsToServer(formToSubmit)
      .pipe(timeout(50000))
      .subscribe(
        async val => {
          const { merchant, completion_details } = val;
          loginBtn.innerHTML = "LOGIN";
          loginBtn.disabled = false;
          // this.mockstore.merchantID = merchant;
          await this.generalservice.saveCompletionStatus(completion_details);
          this.generalservice.setMerchantID(merchant);

          this.generalservice.setToken(val.token);
          this.generalservice.saveLoggedInUserEmail(emailOrPassword);
          // this.mockstore.insertToken = val.token;

          this.generalservice.sendNotificationToGetProfile(
            "get_merchant_profile"
          );
          this.router.navigate(["/dashboard"]);
        },
        err => {
          loginBtn.innerHTML = "LOGIN";
          loginBtn.disabled = false;
          this.generalservice.handleError(err);
        }
      );
    // this.toastr.success("Successful test", "Success");
  }

  //  this function will check if the user entered something similar to an email or a number
  checkIfUserEnteredAnEmailOrPassword(emailOrPassword): object {
    // isNaN checks if a number is actually a number and will return
    // true it is not a number and false if it is a number
    if (!isNaN(emailOrPassword)) {
      return { phone: emailOrPassword };
    }
    const emailRegex = this.mockstore.emailRegex;
    if (emailRegex.test(emailOrPassword)) {
      return { email: emailOrPassword };
    }
  }
}
